import db from '@/utils/localstorage'
import Vue from 'vue'
export default {
  namespaced: true,
  state: {
    token: db.get('ACCESS_TOKEN'),
    refreshToken: db.get('REFRESH_TOKEN'),
    routeToken: db.get('ROUTE_TOKEN', null),
    expireTime: db.get('EXPIRE_TIME', 0),
    user: db.get('USER'),
    permissions: db.get('PERMISSIONS'),
    routes: db.get('USER_ROUTER') || [],
    name: '',
    avatar: '',
    introduction: '',
    roles: []
  },
  mutations: {
    setAccessToken(state, val) {
      db.save('ACCESS_TOKEN', val)
      state.token = val
      // 保留旧字段，避免仍读取 accessToken 的存量页面受到影响。
      state.accessToken = val
    },
    setRefreshToken(state, val) {
      db.save('REFRESH_TOKEN', val)
      state.refreshToken = val
    },
    setExpireTime(state, val) {
      db.save('EXPIRE_TIME', val)
      state.expireTime = val
    },
    setUser(state, val) {
      db.save('USER', val)
      state.user = val
    },
    setPermissions(state, val) {
      db.save('PERMISSIONS', val)
      state.permissions = val
    },
    setRoutes(state, val) {
      db.save('USER_ROUTER', val)
      state.routes = val
    },
    setRouteToken(state, val) {
      db.save('ROUTE_TOKEN', val)
      state.routeToken = val
    }
  },
  actions: {
    // keycloakLogin
    keycloakLogin({ commit }, accessToken) {
      return new Promise((resolve, reject) => {
        const currentRouterInfo = localStorage.getItem('currentRouterInfo')
        if (!currentRouterInfo) {
          window.history.pushState('', '', '/')
          localStorage.setItem('currentRouterInfo', true)
        }
        commit('setAccessToken', accessToken)
        resolve()
      })
    },
    // get user info from keycloak
    getKeycloakInfo({ commit, state }) {
      return new Promise((resolve, reject) => {
        localStorage.removeItem('USER')
        localStorage.removeItem('USER_ROUTER')
        if (!Vue.prototype.$keycloak) {
          reject('keycloak not init')
        }

        if (!Vue.prototype.$keycloak.authenticated) {
          reject('Verification failed, please Login again.')
        }

        const roles = Vue.prototype.$keycloak.realmAccess.roles
        // resourceAccess.security.roles：客户端级角色（如 yelink-developer 存于此处）
        const resourceAccess = Vue.prototype.$keycloak.resourceAccess || {}
        const securityRoles = (resourceAccess.security && resourceAccess.security.roles) || []
        const username = Vue.prototype.$keycloak.idTokenParsed.preferred_username
        const avatar = Vue.prototype.$keycloak.idTokenParsed.avatar
        const introduction = Vue.prototype.$keycloak.idTokenParsed.introduction

        // roles must be a non-empty array
        if (!roles || roles.length <= 0) {
          reject('getKeycloakInfo: roles must be a non-null array!')
        }
        const data = {
          roles,
          securityRoles,
          username,
          avatar,
          introduction
        }
        commit('setUser', data)
        resolve(data)
      })
    },

    // keycloakLogout
    keycloakLogout({ commit, state }) {
      db.clear()
      return new Promise((resolve, reject) => {
        Vue.prototype.$keycloak.keycloak.logout().then(() => {
          const currentHash = window.location.hash
          const newHref = window.location.href.toString().replace(currentHash, '') + '#' + 'b'

          window.location.replace(newHref)
          commit('setAccessToken', '')
          commit('user', [])
          db.clear()
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    }
  }
}
